module.exports = __webpack_public_path__ + "static/media/header_bg.0e5719dd.png";